var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightingInteriorilluminationLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0.25V0.75C15.75 1.01522 15.6446 1.26957 15.4571 1.45711C15.2696 1.64464 15.0152 1.75 14.75 1.75H1.25C0.984784 1.75 0.73043 1.64464 0.542893 1.45711C0.355357 1.26957 0.25 1.01522 0.25 0.75V0.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.75C12.25 2.88261 12.3027 3.00979 12.3964 3.10355C12.4902 3.19732 12.6174 3.25 12.75 3.25H13.75C13.8826 3.25 14.0098 3.19732 14.1036 3.10355C14.1973 3.00979 14.25 2.88261 14.25 2.75V1.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 4.25V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.25C12.587 5.25 11.9511 5.51339 11.4822 5.98223C11.0134 6.45107 10.75 7.08696 10.75 7.75H15.75C15.75 7.08696 15.4866 6.45107 15.0178 5.98223C14.5489 5.51339 13.913 5.25 13.25 5.25V5.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.75V9.25H14.25V8.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.75C7 2.88261 7.05268 3.00979 7.14645 3.10355C7.24021 3.19732 7.36739 3.25 7.5 3.25H8.5C8.63261 3.25 8.75979 3.19732 8.85355 3.10355C8.94732 3.00979 9 2.88261 9 2.75V1.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.25V8.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5C7.33696 8.5 6.70107 8.76339 6.23223 9.23223C5.76339 9.70107 5.5 10.337 5.5 11H10.5C10.5 10.337 10.2366 9.70107 9.76777 9.23223C9.29893 8.76339 8.66304 8.5 8 8.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12V12.5H9V12",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.75C1.75 2.88261 1.80268 3.00979 1.89645 3.10355C1.99021 3.19732 2.11739 3.25 2.25 3.25H3.25C3.38261 3.25 3.50979 3.19732 3.60355 3.10355C3.69732 3.00979 3.75 2.88261 3.75 2.75V1.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.25V11.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11.75C2.08696 11.75 1.45107 12.0134 0.982233 12.4822C0.513392 12.9511 0.25 13.587 0.25 14.25H5.25C5.25 13.587 4.98661 12.9511 4.51777 12.4822C4.04893 12.0134 3.41304 11.75 2.75 11.75Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 15.25V15.75H3.75V15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingInteriorilluminationLamp);
export default __webpack_public_path__ + "static/media/lighting-interior illumination-lamp.bd832812.svg";
export { ForwardRef as ReactComponent };